"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdPlatformOpenIDProviderApi = exports.SdPlatformOpenIDProviderEmbeddableFields = void 0;
const SdPlatformRequestId_1 = require("../api/SdPlatformRequestId");
const ResourcesApi_1 = require("./commons/ResourcesApi");
var SdPlatformOpenIDProviderEmbeddableFields;
(function (SdPlatformOpenIDProviderEmbeddableFields) {
    SdPlatformOpenIDProviderEmbeddableFields["Organization"] = "organization";
})(SdPlatformOpenIDProviderEmbeddableFields = exports.SdPlatformOpenIDProviderEmbeddableFields || (exports.SdPlatformOpenIDProviderEmbeddableFields = {}));
/**
 * Operations for OpenID providers.
 */
class SdPlatformOpenIDProviderApi extends ResourcesApi_1.ResourcesApi {
    get __resourcePath() {
        return "openid_providers";
    }
    /**
    * Get OpenID Provider by id.
    * @param id - openid provider id.
    * @param embed - embeddable resources.
    */
    get(id, embed) {
        return super.__get(SdPlatformRequestId_1.RequestId.OpenIDProviderGet, id, embed);
    }
    /**
     * Query OpenID providers.
     * @param body
     */
    query(body = {}) {
        return super.__query(SdPlatformRequestId_1.RequestId.OpenIDProviderQuery, body);
    }
    /**
     * Create an OpenID provider.
     * @param body
     * @returns
     */
    create(body) {
        return super.__post(SdPlatformRequestId_1.RequestId.OpenIDProviderCreate, body);
    }
    /**
     * Patch an OpenID provider.
     * @param id - id of the OpenID provider
     * @param body - properties to patch
     */
    patch(id, body) {
        return super.__patch(SdPlatformRequestId_1.RequestId.OpenIDProviderPatch, id, body);
    }
    /**
     * Delete an OpenID provider..
     * @param id
     * @returns
     */
    delete(id) {
        return super.__delete(SdPlatformRequestId_1.RequestId.OpenIDPRoviderDelete, id);
    }
}
exports.SdPlatformOpenIDProviderApi = SdPlatformOpenIDProviderApi;
//# sourceMappingURL=SdPlatformOpenIDProviderApi.js.map